import { createSlice } from "@reduxjs/toolkit";
import { VisorDocumentosSliceInterface } from "interfaces/visorDocumentos/visorDocumentosInterface";

export const visorDocumentosSlice = createSlice({
  initialState: {
    posicion: 0,
    documentos: [],
    documentSelected: [],
    documentoSeleccionado: "",
    documentoSeleccionadoCentrales: "",
    openVisor: false,
    numPages: 0,
    pageNo: 1,
    scale: 100,
    abrirVisor: true,
    paginaActual: 0,
    rotation: 0,
    expandir: false,
    ultimaPag: false,
    primeraPag: false,
    lstActuaciones: [],
    arbolData: [],
    nodoSelect: null,
    encabezadoLaboralPenal: "",
    posicionPenal: 0,
    posicionLaboral: 0,
    nodoLaboralPenal: null,
    verDetallesElecttonico: false,
    datosPA: []
  } as VisorDocumentosSliceInterface,
  name: "Visor Documentos",
  reducers: {
    onAddEncabezadoLaboralPenal: (state, { payload }) => {
      state.encabezadoLaboralPenal = payload;
    },
    onAddDocumentPDF: (state, { payload }) => {
      state.documentSelected = payload;
    },
    onAddPaginaActual: (state, { payload }) => {
      state.paginaActual = payload;
    },
    onAddOpenVisor: (state, { payload }) => {
      state.abrirVisor = payload;
    },
    onShowVisor: (state, { payload }) => {
      state.openVisor = payload;
    },
    onChangeNumPages: (state, { payload }) => {
      state.numPages = payload;
    },
    onChangePageNo: (state, { payload }) => {
      state.pageNo = payload;
    },
    onChangeScale: (state, { payload }) => {
      state.scale = payload;
    },
    onChangeExpandir: (state, { payload }) => {
      state.expandir = payload;
    },
    onChangeVerDetallesElect: (state, { payload }) => {
      state.verDetallesElecttonico = payload;
    },
    onChangeRotation: (state, { payload }) => {
      state.rotation = payload;
    },
    onChangeUltimaPag: (state, { payload }) => {
      state.ultimaPag = payload;
    },
    onChangePrimeraPag: (state, { payload }) => {
      state.primeraPag = payload;
    },
    onAllResetState: (state) => {
      state.openVisor = false;
      state.numPages = 0;
      state.pageNo = 1;
      state.scale = 2.5;
      state.documentSelected = [];
      state.rotation = 0;
      state.expandir = false;
      state.ultimaPag = false;
      state.primeraPag = false;
      state.encabezadoLaboralPenal = "";
      state.verDetallesElecttonico = false;
    },
    onDocumentoSeleccionado: (state, { payload }) => {
      state.documentoSeleccionado = payload;
    },
    onDocumentoSeleccionadoCentrales: (state, { payload }) => {
      state.documentoSeleccionadoCentrales = payload;
    },
    onAddDocumentos: (state, { payload }) => {
      state.documentos = payload;
    },
    onPosicion: (state, { payload }) => {
      state.posicion = payload;
    },
    onPosicionLaboral: (state, { payload }) => {
      state.posicionLaboral = payload;
    },
    onPosicionPenal: (state, { payload }) => {
      state.posicionPenal = payload;
    },
    onAddArbolVisor: (state, { payload }) => {
      state.arbolData = payload;
    },

    onAddDatosPA: (state, { payload }) => {
      state.datosPA = payload;
    },
    onAddActuaciones: (state, { payload }) => {
      state.lstActuaciones = payload;
    },
    onAddNodoSelect: (state, { payload }) => {
      state.nodoSelect = payload;
    },
    onAddNodoLabPenal: (state, { payload }) => {
      state.nodoLaboralPenal = payload;
    },
  },
});

export const {
  onShowVisor,
  onChangeNumPages,
  onChangePageNo,
  onChangeScale,
  onAddDocumentPDF,
  onAllResetState,
  onDocumentoSeleccionado,
  onAddDocumentos,
  onPosicion,
  onAddOpenVisor,
  onAddPaginaActual,
  onChangeRotation,
  onChangeExpandir,
  onChangeUltimaPag,
  onChangePrimeraPag,
  onAddActuaciones,
  onAddArbolVisor,
  onAddNodoSelect,
  onAddEncabezadoLaboralPenal,
  onPosicionLaboral,
  onPosicionPenal,
  onAddNodoLabPenal,
  onDocumentoSeleccionadoCentrales,
  onChangeVerDetallesElect,
  onAddDatosPA,
} = visorDocumentosSlice.actions;
